<section
  *ngIf="opinions && opinions.length > 0"
  class="bg-gray-50 py-16 md:py-20"
>
  <div class="container mx-auto px-4">
    <!-- Título simplificado -->
    <div class="text-center mb-8 sm:mb-12">
      <h2 class="text-2xl md:text-4xl font-bold text-primary mb-3">
        Lo que dicen nuestros clientes
      </h2>
      <div class="flex items-center justify-center gap-1 text-secondary mb-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
      </div>
      <p class="text-sm sm:text-base text-gray-600">
        Miles de familias confían en nosotros
      </p>
    </div>

    <!-- Carrusel infinito de opiniones -->
    <div class="relative overflow-hidden py-4 -mx-4 sm:mx-0">
      <div
        class="flex gap-4 sm:gap-6 md:gap-8 animate-scroll-infinite hover:pause-animation"
      >
        <!-- Primera copia de las tarjetas -->
        <div
          *ngFor="let item of opinions"
          class="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-5 sm:p-6 md:p-8 flex flex-col flex-shrink-0 w-64 sm:w-80 md:w-96"
        >
          <!-- Estrellas y fecha -->
          <div class="flex justify-between items-center mb-4">
            <div class="flex gap-0.5">
              <svg
                *ngFor="let i of [].constructor(item.stars)"
                class="w-4 h-4 text-secondary fill-current"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>
            </div>
            <span class="text-xs text-gray-500">{{
              item.date | date : "dd/MM/yyyy"
            }}</span>
          </div>

          <!-- Mensaje -->
          <div class="flex-1 mb-4">
            <p class="text-gray-700 leading-relaxed text-sm">
              "{{ item.message }}"
            </p>
          </div>

          <!-- Cliente -->
          <div class="flex items-center gap-3 pt-4 border-t border-gray-100">
            <div
              class="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white font-bold text-sm"
            >
              {{ item.client_name.charAt(0).toUpperCase() }}
            </div>
            <div>
              <p class="font-bold text-primary text-sm">
                {{ item.client_name }}
              </p>
              <p class="text-xs text-gray-500">Cliente verificado</p>
            </div>
          </div>
        </div>

        <!-- Segunda copia de las tarjetas para efecto infinito -->
        <div
          *ngFor="let item of opinions"
          class="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-5 sm:p-6 md:p-8 flex flex-col flex-shrink-0 w-64 sm:w-80 md:w-96"
        >
          <!-- Estrellas y fecha -->
          <div class="flex justify-between items-center mb-4">
            <div class="flex gap-0.5">
              <svg
                *ngFor="let i of [].constructor(item.stars)"
                class="w-4 h-4 text-secondary fill-current"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>
            </div>
            <span class="text-xs text-gray-500">{{
              item.date | date : "dd/MM/yyyy"
            }}</span>
          </div>

          <!-- Mensaje -->
          <div class="flex-1 mb-4">
            <p class="text-gray-700 leading-relaxed text-sm">
              "{{ item.message }}"
            </p>
          </div>

          <!-- Cliente -->
          <div class="flex items-center gap-3 pt-4 border-t border-gray-100">
            <div
              class="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white font-bold text-sm"
            >
              {{ item.client_name.charAt(0).toUpperCase() }}
            </div>
            <div>
              <p class="font-bold text-primary text-sm">
                {{ item.client_name }}
              </p>
              <p class="text-xs text-gray-500">Cliente verificado</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
